import React, { useEffect, useState } from "react";
import { FormikProvider, Form, useFormik } from "formik";
import SwaranandhraService from "../../Services/SwaranandhraService";
import ShowAlert from "../alert";
import Menubar from "../Menubar";
import { Button, Row, Col, Container, Form as BootstrapForm } from 'react-bootstrap';

//

const UserList = ({ users, onTerminate, searchText }) => {
  const filteredData = searchText.length > 0
    ? users.filter(item => Object.keys(item).some(key => item[key]?.toString().toLowerCase().includes(searchText.toLowerCase())))
    : users;

  return (
    <div className='indicators-info'>
      {filteredData.map((detail, i) => (
        <div key={i} className="activity-box d-flex mt-2">
          <div className="number-box-main d-flex">
            <div className="number-box"><p>{i + 1}</p></div>
            <div className="number-text"><p style={{ fontSize: "17px" }}>{detail.userId}</p></div>
          </div>
          <div className="ha-box1 text-center"><p style={{ fontSize: "17px" }}>{detail.userLoggedInDate}</p></div>
          <Button variant="" size="sm" style={{ textAlign: 'center' }} onClick={() => onTerminate(detail.userId)}>
            <img src="../images/bin.webp" className="img-fluid bin-img" alt="delete" />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default function Activeusers() {
  const [userslist, setUserslist] = useState([]);
  const [blockeduserslist, setBlockeduserslist] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchText1, setSearchText1] = useState("");

  const formik = useFormik({ initialValues: {} });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const activeUsers = await SwaranandhraService.activeUsers();
        if (activeUsers.data) {
          setUserslist(activeUsers.data);
        } else {
          ShowAlert(activeUsers.data.SDESC, "error");
        }

        const blockedUsers = await SwaranandhraService.blockedList();
        if (blockedUsers.data) {
          setBlockeduserslist(blockedUsers.data);
        } else {
          ShowAlert(blockedUsers.data.SDESC, "error");
        }
      } catch (error) {
        ShowAlert("An error occurred", "error");
      }
    };

    fetchData();
  }, []);

  const handleTerminate = async (id) => {
    try {
      const params = { userId: id.toString() };
      const response = await SwaranandhraService.userlogoutByManuallyUser(params);
      if (response.data && response.data.SCODE === "01") {
        setUserslist(userslist.filter(item => item.userId !== id));
        ShowAlert(`${id} User Successfully ${response.data.SDESC}`, "success");
      } else {
        ShowAlert(response.data.SDESC, "error");
      }
    } catch (error) {
      ShowAlert("An error occurred", "error");
    }
  };

  const handleRemove = async (id) => {
    try {
      const response = await SwaranandhraService.removeBlockedUsers(id);

      if (response.data && response.data.SCODE === "01") {
        // Filter out the user from the blocked users list
        setBlockeduserslist(blockeduserslist.filter(item => item.userId !== id));
        // Show success alert
        ShowAlert(response.data.SDESC, "success");
      } else {
        // Show error alert if SCODE is not "01"
        ShowAlert(response.data.SDESC, "error");
      }
    } catch (error) {
      // Handle error if the request fails
      ShowAlert("Error occurred while removing the user", "error");
      console.error("Error:", error);
    }
  };


  return (
    <>
      <Menubar />

      <Container fluid className='map-header mx-2'>
        <div className='sa-title'>
          <h2>Active <span>Users</span></h2>
        </div>
      </Container>
      <Container fluid>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6}>
                <div className='active-indicators'>
                  <h5>Login Users</h5>
                  <BootstrapForm inline className='search-bar'>
                    <Row>
                      <Col>
                        <input type="text" className="form-control" placeholder="Search" onChange={(e) => setSearchText(e.target.value)} />
                      </Col>
                    </Row>
                  </BootstrapForm>
                  <UserList users={userslist} onTerminate={handleTerminate} searchText={searchText} />
                </div>
              </Col>

              <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6}>
                <div className='indicators1'>
                  <h5>Blocked Users Details</h5>
                  <BootstrapForm inline className='search-bar'>
                    <Row>
                      <Col>
                        <input type="text" className="form-control" placeholder="Search" onChange={(e) => setSearchText1(e.target.value)} />
                      </Col>
                    </Row>
                  </BootstrapForm>
                  <UserList users={blockeduserslist} onTerminate={handleRemove} searchText={searchText1} />
                </div>
              </Col>
            </Row>
          </Form>
        </FormikProvider>
      </Container>
    </>
  );
}

